import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  getAnalyticsConsent,
  initAnalytics,
  isAnalyticsConfigured,
  setAnalyticsConsent,
} from '@/lib/analytics';

export function AnalyticsConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isAnalyticsConfigured()) return;
    const consent = getAnalyticsConsent();
    if (consent === null) {
      setVisible(true);
      return;
    }
    if (consent) {
      initAnalytics();
    }
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 rounded-xl border border-border bg-card p-4 shadow-xl md:left-auto md:max-w-md">
      <p className="text-sm text-muted dark:text-foreground">
        Wir verwenden Analyse-Tools (GA4, Clarity, LinkedIn), um Produkt und Marketing zu verbessern.
      </p>
      <p className="mt-1 text-xs text-muted">
        Es werden keine sensiblen personenbezogenen Daten an Tracking-Dienste gesendet.
      </p>
      <div className="mt-3 flex items-center justify-end gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            setAnalyticsConsent(false);
            setVisible(false);
          }}
        >
          Ablehnen
        </Button>
        <Button
          size="sm"
          onClick={() => {
            setAnalyticsConsent(true);
            setVisible(false);
          }}
        >
          Akzeptieren
        </Button>
      </div>
    </div>
  );
}
